module.exports = __webpack_public_path__ + "static/media/OW.85fa4dda.png";